/**
 * HTTP-клиент публичного SPA: конверт `{ data, error }` (E07).
 */

import { API_V1_PREFIX, apiFailureSchema } from "@potok/shared";

/** Ошибка API с кодом из конверта. */
export class ApiRequestError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = "ApiRequestError";
  }
}

type RequestOptions = {
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: unknown;
};

/**
 * Запрос к публичному API, разворачивает `data`.
 * @throws ApiRequestError
 */
export async function apiRequest<T>(path: string, options: RequestOptions = {}): Promise<T> {
  const headers: Record<string, string> = {};
  let body: BodyInit | undefined;
  if (options.body !== undefined) {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(options.body);
  }

  const response = await fetch(`/${API_V1_PREFIX}${path}`, {
    method: options.method ?? "GET",
    headers,
    ...(body === undefined ? {} : { body }),
  });
  const payload = (await response.json().catch(() => null)) as unknown;

  if (!response.ok) {
    const parsed = apiFailureSchema.safeParse(payload);
    throw new ApiRequestError(
      parsed.success ? parsed.data.error.code : "INTERNAL",
      parsed.success ? parsed.data.error.message : "Сервис временно недоступен",
      response.status,
    );
  }

  return (payload as { data: T }).data;
}
